/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/js/ObfLinks.js
class ObfLinks {
  init = () => {
    this.eventTypes = ['mouseover', 'focusin'];

    this.links = document.querySelectorAll('[data-href]');

    if (this.links.length > 0) {
      this.eventTypes.forEach((eventType) => {
        document.addEventListener(eventType, () =>
          this.mouseOverHandler(this.links)
        );
      });

      this.links.forEach((item) => {
        item.addEventListener('click', () => this.clickHandler(item));
      });
    }
  };

  mouseOverHandler = (links) => {
    links.forEach((item) => this.transformHref(item));
    this.eventTypes.forEach((eventType) => {
      document.removeEventListener(eventType, this.mouseOverHandler);
    });
  };

  transformHref = (element) => {
    if (element.dataset.href) {
      element.href = atob(element.dataset.href);
      delete element.dataset.href;
    }
  };

  clickHandler = (item) => {
    this.transformHref(item);
    item.removeEventListener('click', this.clickHandler);
  };
}

;// CONCATENATED MODULE: ./src/js/ReadMore.js
class ReadMore {
  init = () => {
    this.button = document.querySelector(".wq-read-more__button");
    this.target = document.querySelector(".wq-read-more__target");

    if (this.button && this.target) {

      const targetY = this.target.getBoundingClientRect().y;

      this.button.addEventListener('click', () => {
        if (targetY) {
          this.scrollToTarget(targetY);
        }
      });
    }
  }

  scrollToTarget = (top) => {
    window.scrollTo({
      top: top,
      behavior: "smooth",
    });
  }
}
;// CONCATENATED MODULE: ./src/main.js


// JS goes here



window.addEventListener('load', () => {
  const classes = [new ObfLinks(), new ReadMore()];
  classes.forEach((classe) => {
    classe.init();
  });
});
/******/ })()
;